import RightControlPanel from './RightControlPanel';

export default RightControlPanel;
